"use client";

import { useEffect, useRef } from "react";

import { waitForSessionId } from "@repo/ui/lib/tabSessionId";

import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchStationsThunk } from "../slices/stationsSlice";

export function StationsHydrator() {
  const dispatch = useAppDispatch();
  const hasFetched = useRef(false);
  const stations = useAppSelector((state) => state.stations.stations);

  useEffect(() => {
    // If we already have stations (e.g., from persist) or we already fetched, don't fetch again
    if (hasFetched.current || stations !== null) return;

    waitForSessionId().then((sessionId) => {
      if (sessionId && !hasFetched.current) {
        hasFetched.current = true;
        dispatch(fetchStationsThunk(sessionId));
      }
    });
  }, [dispatch, stations]);

  return null;
}
